import Image from "next/image";
import Link from "next/link";
import getConfig from "next/config";

import SubLayout from "@/containers/layout/LandingLayout/SubLayout";
import { FC } from "react";

const { publicRuntimeConfig } = getConfig();

const Hero: FC = () => {
  return (
    <div className="w-full pt-7 text-white md:pt-14 pb-20 md:pb-0 xl:pt-24 bg-landing-ivory md:h-[33.25rem] relative xl:h-[41rem]">
      <SubLayout>
        <div className="relative flex flex-col items-center justify-start xl:mx-auto xs:justify-center md:justify-start md:flex-row max-w-screen-2xl">
          <div className="w-full mb-10 xs:w-fit xl:ml-16 md:w-2/5 md:pt-0 xl:pb-12">
            <h1>
              <span className="text-4xl font-bold md:text-5xl whitespace-nowrap xl:text-7xl text-landing-blue">
                Help your clients&nbsp;
              </span>
              <span className="block mt-2 text-4xl font-bold md:text-5xl whitespace-nowrap text-landing-cherry xl:text-7xl">
                seal the deal
              </span>
            </h1>
            <h2 className="text-landing-blue font-serif text-xl max-w-xs xs:max-w-md md:max-w-none xl:text-2xl md:mt-4 xl:mt-7 md:leading-8 mt-7 md:w-[19.8rem] xl:w-[30.375rem]">
              Our zero-deposit, rent to buy solution provides an easy, flexible and fast offer that
              you can rely on.
            </h2>
            <Link href={`${publicRuntimeConfig?.BROKER_PORTAL_URL}/sign-up`}>
              <a className="inline-block px-4 py-3 w-full md:w-auto text-center mx-auto text-base font-bold text-white transition duration-300 ease-in-out transform rounded shadow mt-7 xl:mt-9 bg-landing-cherry hover:scale-105">
                Join the network
              </a>
            </Link>
          </div>

          <div className="relative xs:right-auto z-40 md:mt-48 xl:mt-2 flex-grow h-72 xl:w-[49.375rem] xl:h-[37.5rem]  md:h-96 w-[36.75rem] transform scale-110 md:absolute -right-10 md:-right-28 xl:-right-20 md:scale-100">
            <Image
              src="/intermediaries/hero-desktop.svg"
              alt="home image"
              objectFit="contain"
              priority
              layout="fill"
            />
          </div>
        </div>
      </SubLayout>
    </div>
  );
};

export default Hero;
